import React, { useEffect } from 'react'
import './Logo.scss'
import animatedLogo from './LogoFunction.js'

const Logo = () => {
  useEffect(animatedLogo, [])

  return (
    <div className="logo-container">
      <svg
        className="svg-container"
        version="1.1"
        baseProfile="tiny"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 600 800"
        xmlSpace="preserve"
        onClick={animatedLogo}
      >
        <circle className="svg-circle parent" cx="299.5" cy="349.5" r="280.5" />
        <circle className="svg-circle child" cx="299.5" cy="349.5" r="200.5" />
        <polyline
          className="svg-polyline inside"
          points="405,515 240,350 300,350 440,480 "
        />
        <polyline
          className="svg-polyline outside"
          points="460,585 530,660 580,660 490,555 "
        />
      </svg>
    </div>
  )
}

export default Logo
